import { ref } from 'vue'
import { defineStore } from 'pinia'
export const useRegisteredStore = defineStore('registered', () => {
  const registered = ref(false)

  return { registered }
})
